export enum LOOKUP_AREA_TYPES {
	Region = "Region",
	Council = "Council",
	BeachSite = "Site",
	RegionBeachSite = "RegionBeachSite",
	CouncilBeachSite = "CouncilBeachSite"
};